import { DocStatusEnum } from './types';

export const WARNING_MESSAGES_STATUSES = {
  [DocStatusEnum.MISMATCHED_RNOKPP]: 'РНОКПП',
  [DocStatusEnum.MISMATCHED_EDRPOU]: 'ЄДРПОУ',
  [DocStatusEnum.MISMATCHED_FULLNAME]: 'ПІБ',
  [DocStatusEnum.ORGANIZATION_ABSENT]: 'Найменування організації',
  [DocStatusEnum.INVALID_SIGNATURE]:
    'Після перевірки документів виявлено, що цей документ має неналежний КЕП. Будь ласка, перевірте документ та підпишіть його повторно.',
  [DocStatusEnum.SIGNED_WITH_ELECTRONIC_STAMP]:
    "Для підписання необхідний особистий КЕП, виданий організацією на ім'я підписанта. Електронна печатка організації не приймається.",
  [DocStatusEnum.SUCCESS]: '',
  [DocStatusEnum.NOT_VERIFIED]: '',
};

export enum DOCUMENT_WEB_BLOCK {
  MAIN = 'MAIN',
  ADDITIONAL_MAIN = 'ADDITIONAL_MAIN',
  ADDITIONAL = 'ADDITIONAL',
}

export enum DOCUMENT_RELATED_ENTITY_TYPE {
  REPRESENTATIVE = 'REPRESENTATIVE', // розпорядники
  UBO = 'UBO', // кбв
  FOREIGN_LEGAL_ENTITY = 'FOREIGN_LEGAL_ENTITY', // поки не треба
  CONTROLLING_PERSON = 'CONTROLLING_PERSON', // CRS-CP
  FATCA_SUBSTANTIAL_US_OWNER = 'FATCA_SUBSTANTIAL_US_OWNER', // фатка
}

export const UPLOAD_DOCUMENT_URL = '/identification/documents/upload';

export const P7S_FILE_TYPES = 'application/pkcs7-signature'; // .p7s

export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/bmp',
  'application/vnd.ms-powerpoint', // .ppt
  'text/plain', // .txt
  P7S_FILE_TYPES,
];

export const MAX_FILE_SIZE = 15 * 1024 * 1024;
export const DATE_CHANGE_ADDITIONAL_VERIFICATION_APPLICATION = new Date(2026, 6, 30); // припиненням формування документа "Заява про заходи додаткової перевірки"

export const ERROR_MESSAGES = {
  MISSING_FORMS_AND_DOCUMENTS: (forms: string[], documents: string[]) => {
    const missingForms = forms.length > 0 ? `\nВідсутні форми: ${forms.join(', ')}` : '';
    const missingDocuments =
      documents.length > 0 ? `\nВідсутні документи: ${documents.join(', ')}` : '';

    return `Заявка не готова до підписання. Необхідно заповнити всі обов’язкові форми та завантажити необхідні документи.${missingForms}${missingDocuments}`;
  },
};
